exports.DEFAULT_LANG = "it";

exports.OTHER_LANGUAGES = ["en"];

exports.ALL_LANGUAGES = [exports.DEFAULT_LANG, ...exports.OTHER_LANGUAGES];

exports.FILES_TO_IGNORE = [".DS_Store"];
